const shopRouter = {
  path: '/shop',
  component: () => import('@/layout/shopHeader'),
  children: [
    {
      path: '',
      name: 'Shop',
      meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "shop" */ '@/pages/shop'),
      children: [
        {
          path: 'livebroadcast/:shop_id',
          name: 'Livebroadcast',
          meta: { keepAlive: true, title: '店铺视频' },
          component: () => import(/* webpackChunkName: "shop-live" */ '@/pages/shop/liveBroadcast')
        },
        {
          path: 'livebroadcast/:shop_id/:channel_id',
          name: 'Livebroadcast-1',
          meta: { keepAlive: true, title: '店铺视频' },
          component: () =>
            import(/* webpackChunkName: "shop-live-1" */ '@/pages/shop/liveBroadcast')
        },
        {
          path: 'shopmap/:shop_id',
          name: 'Shopmap',
          meta: { keepAlive: true, title: '店铺地图' },
          component: () => import(/* webpackChunkName: "shop" */ '@/pages/shop/map')
        },
        {
          path: 'photo/:shop_id',
          name: 'Photo',
          meta: { keepAlive: true, title: '相册' },
          component: () => import(/* webpackChunkName: "shop" */ '@/pages/shop/photo')
        },
        {
          path: 'kyb/:domainId',
          name: 'kyb',
          meta: { keepAlive: true, noRequest: true },
          component: () => import(/* webpackChunkName: "shop" */ '@/pages/shop/detail')
        },
        {
          path: 'shopLicense',
          name: 'shopLicense',
          meta: { keepAlive: true, title: '店铺经营资质' },
          component: () => import(/* webpackChunkName: "shop" */ '@/pages/shop/shop/shopLicense')
        },
        {
          path: 'joinInvestment',
          name: 'joinInvestment',
          meta: { keepAlive: true, title: '招商加盟列表' },
          component: () => import(/* webpackChunkName: "shop" */ '@/pages/shop/joinInvestment')
        },
        {
          path: 'joinInvestmentApply',
          name: 'joinInvestmentApply',
          meta: { keepAlive: true, title: '招商加盟申请' },
          component: () =>
            import(/* webpackChunkName: "shop" */ '@/pages/shop/joinInvestment/apply')
        },
        {
          path: 'joinInvestmentDetail',
          name: 'joinInvestmentDetail',
          meta: { keepAlive: true, title: '招商加盟详情' },
          component: () =>
            import(/* webpackChunkName: "shop" */ '@/pages/shop/joinInvestment/detail')
        }
      ]
    }
  ]
}

export default shopRouter
